const n = (t) => t ? {
  succeeded: I18n.t("payment_frontend.payment_succeeded"),
  processing: I18n.t("payment_frontend.payment_processing"),
  requires_payment_method: I18n.t("payment_frontend.payment_not_successful")
}[t.status] || I18n.t("payment_frontend.stripe.something_went_wrong", {
  status: t.status
}) : I18n.t("payment_frontend.stripe.no_payment_intent");
export {
  n as getPaymentIntentStatus
};
